<template>
    <div>
    <div class="row">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body shadow">

                    <div class="row mb10" v-if="stage !== 'waiting'">
                        <div class="col-md-4"></div>
                        <div class="col-md-4" style="height: 100px;">
                            <img class="cinc-logo" />
                        </div>
                        <div class="col-md-4"></div>
                    </div>

                    <div class="col-md-12" v-if="stage === 'waiting'">
                        <div class="row">
                            <div class="col-md-5"></div>
                            <div class="col-md-2" style="height: 50px;">
                                <img src="../../assets/loading-blocks.gif" style="width:100%" />
                            </div>
                            <div class="col-md-5"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center" style="padding-top: 60px;">
                                <span>LOADING</span>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-cloak>
                        <div class="col-md-12" v-if="stage === 'scopes'">
                            <h5 class="card-title text-center">CINC would like to:</h5>
                            <div class="row pt10" v-for="scopeItem in scopes" :key="scopeItem.key" v-bind:class="scope.includes(scopeItem.Name) ? '' : 'hidden'">
                                <div class="col-md-1">
                                    <i v-bind:class="scopeItem.Icon"></i>
                                </div>
                                <div class="col-md-10">
                                    {{scopeItem.Description}}
                                </div>
                                <div class="col-md-1">
                                    <i class="fa fa-info-circle" v-bind:title="scopeItem.Details"></i>
                                </div>
                                <hr />
                            </div>
                            <button class="btn btn-lg btn-primary btn-block text-uppercase mt10" type="submit" v-on:click="acceptScopes">Accept</button>
                        </div>

                        <div class="col-md-12" v-else-if="stage === 'credentials'">
                            <div class="mb10 text-center" v-if="scope && !scope.includes('passport')">
                                <small>Enter your credentials to authorize <span class="a-tag pointer" v-on:click="showScopes">{{actionCountText()}}</span></small>
                            </div>
                            <form class="form-signin">
                                <div class="form-label-group mb10">
                                    <input type="text" id="username" v-model="username" class="form-control" placeholder="Username" required autofocus>
                                </div>

                                <div class="form-label-group mb10">
                                    <input type="password" id="password" v-model="password" class="form-control" placeholder="Password" required>
                                </div>

                                <div v-cloak v-if="errorText !== null" class="mb10 text-danger text-center">
                                    <span>{{errorText}}</span>
                                </div>

                                <button class="login-continue btn btn-lg btn-primary btn-block text-uppercase" type="submit" v-on:click="login">Continue</button>
                            </form>
                        </div>

                        <div class="col-md-12" v-else-if="stage === 'domain'">
                            <form class="form-domain">
                                <div class="text-center">
                                    <label for="domainName">Which domain would you like to use?</label>
                                    <select class="form-control mb10" id="domainName" v-model="domainName" autofocus>
                                        <option v-for="domainName in selectableDomainNames" :key="domainName.key">{{domainName}}</option>
                                    </select>
                                </div>

                                <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit" v-on:click="login">Select Domain</button>
                            </form>
                        </div>
                    </div>

                    <div class="row pt10" v-if="stage !== 'waiting'">
                        <div class="col-md-12">
                            <em><small>Such legal.  Much lawyer.  Good privacy.  <a href="/link/to/terms">Very terms.</a></small></em>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { User } from "../../models/User";
import { ScopeDefinition, ScopeDefinitions } from "../../models/ScopeDefinition";
import { FlowData } from "../../models/FlowData";
import { mapGetters } from "vuex";

export default defineComponent({
    name: "Login",
    computed: {
        ...mapGetters({
            User: "userstate/getUser",
        }),
    },
    props: {
        scope: { type: String, default: "" },
        initiator: String,
        client_id: String,
        response_type: String,
        redirect_uri: String,
        state: String,
        domain: { type: String, default: "" },
    },
    setup() {
        let selectedScopes = ref(new Array<string>());
        let scopes = ref(new Array<ScopeDefinition>());

        scopes.value.push(ScopeDefinitions.leads);
        scopes.value.push(ScopeDefinitions.broker);

        return {
            selectedScopes, scopes
        }
    },
    data() {
        return {
            promptForScopes: false,
            selectableDomainNames: Array<String>(),
            stage: "waiting",
            errorText: "",
            waiting: false,
            username: "",
            password: "",
            domainName: this.domain,
            flowData: new FlowData()
        }
    },
    beforeMount() {
        if (this.initiator === "selfserve" ||(this.scope && this.scope.includes("passport"))) {
            this.flowData.scope = this.scope;
            this.stage = "credentials";
        } 
        else {
            this.stage = "scopes";
        }
    },
    methods: {
        actionCountText() {
            const scopeCount = this.scope.split(" ").length;
            if (scopeCount === 1) return "1 scope";
            return scopeCount + " scopes";
        },

        showScopes() {
            this.stage = "scopes";
        },

        acceptScopes() {
            this.stage = "credentials";
        },

        login() {
            this.stage = "waiting";
            this.errorText = "";

            this.flowData.client_id = this.client_id ? this.client_id : "";
            this.flowData.response_type = this.response_type ? this.response_type : "";
            this.flowData.redirect_uri = this.redirect_uri ? this.redirect_uri : "";
            this.flowData.scope = this.scope ? this.scope : "";
            this.flowData.state = this.state ? this.state : "";
            const userObj = {
                username: this.username,
                domainName: this.domainName,
                password: this.password,
                flowData: this.flowData,
                webUrl: window.location.host,
            };
            if (this.username.endsWith("@cincpro.com") && this.password === "") {
                this.$store.state.axiosService.OktaLogin(userObj)
                .then((response:any)=> {
                    window.location.href = response.redirect_uri;
                })
                return;
            }
            this.$store.state.axiosService.Login(userObj)
            .then((response: any) => {
                if (response && response.domains) {
                    this.selectableDomainNames = response.domains;
                    setTimeout(() => (this.stage = "domain"), 1000);
                } 
                else {
                    if (response) {
                        if (response.user && response.user.firstName && response.user.lastName) {
                            this.$store.dispatch("userstate/setUser", new User(response.user.firstName, response.user.lastName, response.user.domainName ?? "", true));
                        }

                        if (response.redirect_uri) {
                            window.location.assign(response.redirect_uri);
                        }

                        return;
                    }

                    this.$router.push({ name: "Intro" });
                }
            })
            .catch((response: Error) => {
                setTimeout(() => {
                this.stage = "credentials";
                this.errorText = response.message;
                this.domainName = "";
                }, 1000);
                console.log("Error logging in.");
            });
        }
    }
})
</script>
